import React, { useEffect, useState } from 'react';
import { Form, Modal, Button, Row, FormInstance } from 'antd';

import { BinaryRadio, EmailInput, IdInput, TextInput } from '../../atom/form';
import { useScreenSize } from '../../../hooks';
import { ActionDefinition, ModalState, renderActionButtons } from '../crud/new-crud-modal';
import { Organization } from 'models/organization';
import { OrganizationTypeDropdown } from './organization-type-dropdown';
import { CountryDropdown } from '../countries/countries-dropdown';
import { StateDropdown } from '../states/states-dropdown';
import { TimezoneDropdown } from 'components/atom/tz-dropdown';
import { ICountry } from 'models';

export type NewOrganizationModalProps = {
  form: FormInstance;
  saving: boolean;
  actions: ActionDefinition<Organization>[];
  modalState: ModalState;
  setModalState: (state: ModalState) => void;
  obj?: Organization;
};

export function NewOrganizationModal(props: NewOrganizationModalProps) {
  const isSmallScreen = useScreenSize();
  const [country, setCountry] = useState<ICountry>();

  const closeModal = () => {
    props.setModalState(ModalState.Hidden);
  };

  useEffect(
    function onLoad() {
      const value = {
        ...props.obj,
      };

      props.form.resetFields();
      props.form.setFieldsValue(value);
    },
    [props.modalState, props.obj],
  );

  return (
    <Modal
      title="New business"
      visible={props.modalState !== ModalState.Hidden}
      onCancel={() => {
        closeModal();
      }}
      footer={
        <Row justify="space-between">
          <Row>
            <Button onClick={closeModal}>Close</Button>
          </Row>
          <Row>{renderActionButtons(props.obj!, props.actions)}</Row>
        </Row>
      }
      width={720}
      wrapClassName={isSmallScreen ? 'fullscreen' : ''}
      className={props.modalState === ModalState.View ? 'read-mode' : ''}
    >
      <Form form={props.form} layout="vertical">
        <IdInput />
        <OrganizationTypeDropdown name="organizationType" label="Business type" required disabled={props.saving} />
        <TextInput name="name" label="Business name" required disabled={props.saving} />
        <TextInput
          name="abn"
          label="Australian Business Number (ABN)"
          disabled={props.saving}
          extra={
            <Button type="link" href="https://abr.business.gov.au" target="blank">
              <span style={{ marginRight: '5px' }}>ABN lookup</span>
              <i className="fa fa-external-link" aria-hidden="true"></i>
            </Button>
          }
        />
        <EmailInput name="email" label="Business email" required disabled={props.saving} />

        <p className="modal-subtitle">Accounting</p>
        <CountryDropdown name="idCountry" required disabled={props.saving} onChange={(c) => setCountry(c)} hideAll />
        <StateDropdown name="idState" idCountry={country?.id} disabled={props.saving} hideAll />
        <TimezoneDropdown name="timezone" label="Timezone" disabled={props.saving} />
        <BinaryRadio name="isGstRegistered" label="Is it registered for Goods and Services Tax (GST)?" required disabled={props.saving} />
      </Form>
    </Modal>
  );
}
